import { Helper } from '@utils/helper';
import { Subscription } from 'rxjs';
import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, AfterViewInit, ChangeDetectorRef } from '@angular/core';

import { ConfirmDialogComponent, ConfirmDialogInterface } from '@components/dialogs/confirm-dialog/confirm-dialog.component';
import { ContratoPagamentoModel } from '@core/models/financeiro/contrato-pagamento.model';
import { GerenciaNetService } from '@services/apis/financeiro/gerencianet.service';
import { TableColumnTypeEnum, TablePipesTypeEnum, TableButtonsEnum } from '@enums/table-custom.enum';
import { TableCustom } from '@core/models/outros/table-custom.model';
import { Toast } from '@services/outros/toast.service';
export interface PaymentsHistoricInterface {
  enrollment: MatriculaGestaoModel,
  contracts: ContratoPagamentoModel[]
}
@Component({
  selector: 'app-payments-historic-dialog',
  templateUrl: './payments-historic-dialog.component.html',
  styleUrls: ['./payments-historic-dialog.component.scss']
})
export class PaymentsHistoricDialogComponent implements OnInit, AfterViewInit {

  contracts: ContratoPagamentoModel[] = new Array<ContratoPagamentoModel>();
  table: TableCustom;
  numero = 0;
  numerodepois = 0;
  private _subscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PaymentsHistoricInterface,
    private _dialog: MatDialog,
    private _gerenciaNetService: GerenciaNetService,
    private _toast: Toast,
    private _cdr: ChangeDetectorRef
  ) {
    this._subscription = new Subscription();
  }

  ngAfterViewInit(): void {
    this.contracts = this.data.contracts;
    this._cdr.detectChanges();
  }

  ngOnInit(): void {
    this._createTable();
  }

  private _cancel(contrato: ContratoPagamentoModel) {
    if (contrato.modoPagamento.formaPagamento.label === 'CARNE') this._cancelBooklet(contrato);
    else if (contrato.modoPagamento.formaPagamento.label === 'BOLETO') this._cancelBillet(contrato);
  }

  private _createTable(): void {
    this.table = {
      columns: ['contratoId', 'descricao', 'provedor', 'valor', 'parcelas', 'ativo', 'actions'],
      title: 'Lista de Contratos',
      data: [],
      result: {
        noData: 'Não foi encontrado contratos para o candidato.',
        defaultMessage: 'Não existe dados para serem exibidos.'
      },
      columnData: {
        contratoId: {
          header: 'CONTRATO ID',
          type: TableColumnTypeEnum.STRING,
          element: 'contratoId'
        },
        descricao: {
          header: 'DESCRIÇÃO',
          type: TableColumnTypeEnum.OBJECT,
          element: 'contrato.descricao'
        },
        provedor: {
          header: 'PROVEDOR',
          type: TableColumnTypeEnum.STRING,
          transformData: (data) => this._getProvedor(data)
        },
        valor: {
          header: 'VALOR',
          type: TableColumnTypeEnum.STRING,
          element: 'valor',
          pipe: TablePipesTypeEnum.CURRENCY
        },
        parcelas: {
          header: 'PARCELAS',
          type: TableColumnTypeEnum.STRING,
          element: 'parcelas'
        },
        ativo: {
          header: 'ATIVO',
          type: TableColumnTypeEnum.STRING,
          element: 'ativo',
          pipe: TablePipesTypeEnum.TRUE_FALSE
        },

        actions: {
          header: 'AÇÕES',
          buttonType: TableButtonsEnum.STROKED,
          type: TableColumnTypeEnum.SINGLE_BUTTON,
          buttons: [
            {
              icon: 'file_download',
              label: 'BAIXAR ARQUIVO',
              onClick: (data) => this._downloadFile(data),
              disabled: (data) => this._check(data),
              styleButton: (data) => this._checkHasItem(data),
              hashButton:'REGISTER_ENROLLMENT_TAB_CONTRACTS_BTN_DOWNLOADBILET'
            },
             {
              icon: 'clear',
              label: 'CANCELAR COBRANÇA',
              onClick: (data) => this._cancel(data),
              disabled: (data) => this._check(data),
              styleButton: (data) => this._checkIsBillet(data),
              hashButton: 'REGISTER_ENROLLMENT_TAB_CONTRACTS_BTN_CANCELBILET'
            }
          ]
        }
      }
    }
  }

  private _downloadFile(element: any): void {
    if (element.linkCobranca) {
      window.open(element.linkCobranca, '_blank');
    } else {
      this._toast.error('Baixar arquivo.', 'Não foi possível processar sua solicitação.');
    }
  }

  private _check(element) {
    return !!!element.codigoProvedor || !element.linkCobranca
  }

  private _checkHasItem(element) {
    if (!element.linkCobranca) {
      return "hidden-button";
    }
    return '';
  }

  private _getProvedor(element) {
    let provedor = '-';
    if (element.provedor) {
      provedor = element.provedor;
    } else if (element.codigoProvedor) {
      provedor = element.codigoProvedor;
    }
    return provedor;
  }

  private _checkIsBillet(element) {
    if (element.modoPagamento.formaPagamento.label == 'BOLETO' || element.modoPagamento.formaPagamento.label == 'CARNE') {
      return '';
    }
    return "hidden-button";
  }

  private _cancelBillet(contrato: ContratoPagamentoModel): void {
    const dialogRef = this._dialog.open<ConfirmDialogComponent, ConfirmDialogInterface>(ConfirmDialogComponent, {
      data: {
        title: 'Cancelamento de Boleto',
        subtitle: 'Tem certeza que deseja cancelar o boleto para o candidato?',
        descriptionFirst: 'Candidato',
        descriptionSecond: this.data.enrollment.candidato.nome,
      },
      width: '488px'
    });

    let lancamento = contrato.contrato.lancamentosFinanceiros.find(x => x.modoPagamentoContaId == contrato.modoPagamentoContaId)

    this._subscription.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const cnpjEmpresa = contrato.contrato.cnpjEmpresa;
          const boletoId = lancamento.boletoId;
          this._gerenciaNetService.deleteBoleto(cnpjEmpresa, boletoId).subscribe(
            () => {
              this._toast.success('Cancelar Boleto', 'Boleto cancelado com sucesso.')
            }
          );
        }
      })
    )
  }

  private _cancelBooklet(contrato: ContratoPagamentoModel): void {
    const dialogRef = this._dialog.open<ConfirmDialogComponent, ConfirmDialogInterface>(ConfirmDialogComponent, {
      data: {
        title: 'Cancelamento de Carnê',
        subtitle: 'Tem certeza que deseja cancelar o carnê para o candidato?',
        descriptionFirst: 'Candidato',
        descriptionSecond: this.data.enrollment.candidato.nome,
      },
      width: '488px'
    });

    let lancamento = contrato.contrato.lancamentosFinanceiros.find(x => x.modoPagamentoContaId == contrato.modoPagamentoContaId)

    this._subscription.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const cnpjEmpresa = contrato.contrato.cnpjEmpresa;
          const carneId = lancamento.carneId;
          this._gerenciaNetService.deleteCarne(cnpjEmpresa, carneId).subscribe(
            () => {
              this._toast.success('Cancelar Carnê', 'Carnê cancelado com sucesso.')
            }
          );
        }
      })
    )
  }
}
